import type { FakeEvidence } from './fakes.types.js';

export function competitors(result: FakeEvidence) {
  return (result.workspaceResources ?? []).filter(
    (r) => r.scope !== 'telegram_directory' && r.roles.includes('competitor'),
  );
}
// Historical facts without a review version retain their original competitor overlay.
export function isCompetitorTone(result: FakeEvidence) {
  return (
    result.classification === 'competitor' ||
    (!result.reviewVersion &&
      competitors(result).length > 0 &&
      ['external', 'unreviewed', 'unknown'].includes(result.classification))
  );
}
export interface SerpChanges {
  entered: number;
  moved: number;
  dropped: Array<{ url: string; rank: number }>;
}
export function serpChanges(
  current: Array<{ url: string; rank: number }>,
  previous: Array<{ url: string; rank: number }> | null,
  top: number,
): SerpChanges | null {
  if (!previous) return null;
  const best = (rows: typeof current) => {
    const map = new Map<string, number>();
    for (const r of rows)
      if (r.rank <= top) map.set(r.url, Math.min(map.get(r.url) ?? Infinity, r.rank));
    return map;
  };
  const now = best(current),
    before = best(previous);
  return {
    entered: [...now].filter(([url]) => !before.has(url)).length,
    moved: [...now].filter(([url, rank]) => before.has(url) && before.get(url) !== rank).length,
    dropped: [...before].filter(([url]) => !now.has(url)).map(([url, rank]) => ({ url, rank })),
  };
}
